"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const items = [
  {
    headline: "Fed holds rates, signals two cuts in 2026",
    source: "Reuters",
    time: "12m ago",
    tone: "optimal" as const,
    tag: "Bullish",
  },
  {
    headline: "Chipmaker guides Q1 revenue above street view",
    source: "Bloomberg",
    time: "48m ago",
    tone: "optimal" as const,
    tag: "Bullish",
  },
  {
    headline: "Regulators open antitrust probe into ad unit",
    source: "WSJ",
    time: "2h ago",
    tone: "alert" as const,
    tag: "Bearish",
  },
  {
    headline: "Oil steadies as supply concerns ease",
    source: "FT",
    time: "3h ago",
    tone: "neutral" as const,
    tag: "Neutral",
  },
]

const Feed = styled.ul`
  margin: 1.25rem 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
`

const Item = styled.li`
  padding: 0.875rem 0;
  border-top: 1px solid color-mix(in oklch, var(--color-border) 60%, transparent);

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`

const Headline = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--color-card-foreground);
  text-wrap: pretty;
`

const Meta = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

const Source = styled.span`
  font-size: 0.75rem;
  color: var(--color-muted-foreground);
`

const Dot = styled.span`
  width: 0.1875rem;
  height: 0.1875rem;
  border-radius: 9999px;
  background: var(--color-muted-foreground);
`

export function NewsFeedCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Market news</Title>
          <Subtitle>Curated up-to-date headlines</Subtitle>
        </TitleGroup>
        <Badge tone="alert" dot={false}>
          Live
        </Badge>
      </CardHeader>

      <Feed>
        {items.map((n) => (
          <Item key={n.headline}>
            <Headline>{n.headline}</Headline>
            <Meta>
              <Source>{n.source}</Source>
              <Dot />
              <Source>{n.time}</Source>
              <div style={{ marginLeft: "auto" }}>
                <Badge tone={n.tone} dot={false}>
                  {n.tag}
                </Badge>
              </div>
            </Meta>
          </Item>
        ))}
      </Feed>
    </Card>
  )
}

export default NewsFeedCard
